// src/pages/Unsubscribe.js
import React, { useState } from "react";

function Unsubscribe() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null); // success message
  const [error, setError] = useState(null); // error message
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that an email was entered
    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }

    setError(null);
    setMessage(null);
    setIsSubmitting(true);

    try {
      // Replace the URL below with your actual unsubscribe API endpoint.
      const response = await fetch(process.env.REACT_APP_UNSUBSCRIBE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        // You can parse a JSON error message from your API if available.
        throw new Error("Failed to unsubscribe. Please try again later.");
      }

      // Optionally, parse the response (if needed)
      // const data = await response.json();

      setMessage("You have been unsubscribed successfully.");
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
  
      <div className="container mx-auto mt-10 max-w-4xl bg-white shadow-md p-10 rounded-md">
        <h1 className="text-xl font-semibold mb-6">Unsubscribe from Emails</h1>
        <p className="text-gray-600 mb-10">
          Please enter your email address below to unsubscribe from our mailing list.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              className="w-full p-2 border rounded-md"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isSubmitting}
            />
          </div>

          {error && <p className="text-red-500 mb-6">{error}</p>}
          {message && <p className="text-green-500 mb-6">{message}</p>}

          <button
            type="submit"
            className="bg-blue-500 text-white py-2 px-6 rounded-md hover:bg-blue-600 disabled:bg-blue-300"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Unsubscribing..." : "Unsubscribe"}
          </button>
        </form>

        <p className="mt-4 text-sm text-gray-500 italic">
          If you did not subscribe or have any issues, please contact our support.
        </p>
      </div>
    
  );
}

export default Unsubscribe;
